import React, { useEffect, useState } from 'react'
import { ajaxPerso } from '../../../fnc'
import ShopifySearchProduct from '../ShopifySearchProduct';

export default function SpecialPromoPage(props){
	const [newSpecialPromoPageItem, setNewSpecialPromoPageItem] = useState(null);
	const [currentSpecialPageInfo, setCurrentSpecialPageInfo] = useState(null);

	const fetchCurrentSpecialPageItem = callback => {
		if(!props.shopSelected || !props.shopSelected.id) return;
		props.loading(true);
		ajaxPerso({api: 'shopify', trigger: 'get_special_promo_page_items', method: 'GET', shop: props.shopSelected.id}, response => {
			props.loading(false);
			if(response && response.success){
				setCurrentSpecialPageInfo(response.data);
				if(callback) callback(response.data);
			}else props.info({error: (response && response.errors) || 'Unable to load the special promo page.'});
		});
	};

	useEffect(() => {
		setNewSpecialPromoPageItem(null);
		setCurrentSpecialPageInfo(null);
		fetchCurrentSpecialPageItem();
	}, [props.shopSelected.id]);

	const executeCleaning = (args = {}, successMessage = 'Old items removed') => {
		props.loading(true);
		ajaxPerso({api: 'shopify', trigger: 'specialPromoDesc_cleanup', method: 'GET', shop: props.shopSelected.id, ...args}, response => {
			props.loading(false);
			if(response && response.data && response.data.executed){
				fetchCurrentSpecialPageItem(() => props.info({success: successMessage}));
			}else props.info({error: (response && response.errors) || 'Unable to update the special promo page.'});
		});
	};

	const triggerModal = () => {
		const currentItems = [...((currentSpecialPageInfo && currentSpecialPageInfo.db_result) || [])];
		props.modal({
			key: 'Special Promo',
			show: true,
			title: 'Special promo page items',
			html: () => <div className="p-2">{currentItems.length === 0? <div className="text-muted p-3 text-center">No products are currently listed on the special promo page.</div> : <div className="table-responsive"><table className="table table-sm mb-0"><thead><tr><th>Product ID</th><th>Title</th><th /></tr></thead><tbody>{currentItems.map((item, index) => <tr key={`${item.id_product_shopify}_${item.handle}`}><td>{item.id_product_shopify}</td><td>{item.title}</td><td className="text-right"><button type="button" className="btn btn-outline-danger btn-sm" onClick={event => {
				currentItems.splice(index, 1);
				setCurrentSpecialPageInfo(current => ({...current, db_result: currentItems.slice()}));
				event.currentTarget.closest('tr').remove();
			}}>Remove</button></td></tr>)}</tbody></table></div>}</div>,
			exit: (popup, close) => close(),
			ok: {
				title: 'Save changes',
				fnc: () => {
					const handles = currentItems.map(item => item.handle);
					executeCleaning({handleList: handles.join(',')}, 'Special promo page updated');
				}
			},
			return: {title: 'Close', fnc: (popup, close) => close()}
		});
	};

	const addItemToSpecialPage = () => {
		if(!newSpecialPromoPageItem){
			props.info({error: 'Please select a product.'});
			return;
		}
		if(!currentSpecialPageInfo){
			props.info({error: 'The current special promo page is still loading. Please try again.'});
			return;
		}
		const handles = ((currentSpecialPageInfo.db_result || []).map(item => item.handle));
		if(!handles.includes(newSpecialPromoPageItem.handle)) handles.push(newSpecialPromoPageItem.handle);
		executeCleaning({handleList: handles.join(',')}, 'Product added to the special promo page');
		setNewSpecialPromoPageItem(null);
	};

	const pageItemCount = currentSpecialPageInfo && currentSpecialPageInfo.meta_value? currentSpecialPageInfo.meta_value.length : 0;

	return <section className="special-promo-page" aria-label="Special promo page">
		<header className="special-promo-page__header">
			<div>
				<h2>Special promo page</h2>
				<p>Choose which promoted products appear on the dedicated Shopify promotion page.</p>
			</div>
			<div className="special-promo-page__count"><strong>{pageItemCount}</strong><span>{pageItemCount === 1? 'product shown' : 'products shown'}</span></div>
		</header>
		<div className="special-promo-page__card">
			<div className="special-promo-page__picker">
				<div>
					<span className="special-promo-page__label">Add a promoted product</span>
					<ShopifySearchProduct
						{...props}
						className="btn btn-primary"
						shopId={props.shopSelected.id}
						title="Select a product"
						itemSelected={newSpecialPromoPageItem? newSpecialPromoPageItem.id_variant_shopify : null}
						updateItem={item => {
							setNewSpecialPromoPageItem(item);
						}}
					/>
				</div>
				{newSpecialPromoPageItem? <div className="special-promo-page__selected"><span className="special-promo-page__label">Ready to add</span><strong>{newSpecialPromoPageItem.title || newSpecialPromoPageItem.sku}</strong><span>SKU: {newSpecialPromoPageItem.sku || '—'} · {newSpecialPromoPageItem.handle}</span></div> : <div className="special-promo-page__empty"><i className="bi bi-stars" aria-hidden="true" />No product selected</div>}
				<button type="button" className="btn btn-success special-promo-page__add" onClick={addItemToSpecialPage} disabled={!newSpecialPromoPageItem}>Add to page</button>
			</div>
			<div className="special-promo-page__management">
				<div><strong>Manage page content</strong><span>Review the current products or remove old entries that no longer have a valid promo.</span></div>
				<div className="special-promo-page__management-actions"><button type="button" className="btn btn-outline-primary" onClick={triggerModal}>Review products <span className="badge badge-light ml-1">{pageItemCount}</span></button>{pageItemCount > 1 && <button type="button" className="btn btn-outline-warning" onClick={() => executeCleaning()}>Clean up old items</button>}</div>
			</div>
		</div>
	</section>;
}
